import * as React from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import DrawerComponent from "./Drawer";
import { imgRoot } from "../../constant/app-paths";

const useStyles = makeStyles((theme) => ({
  navlinks: {
    marginLeft: theme.spacing(10),
    display: "flex",
  },
  logo: {
    flexGrow: 1,
    cursor: "pointer",
  },
  appBarBg: {
    background: "#333",
  },
  imgDesktop: {
    width: "20rem",
  },
  imgMobile: {
    width: "10rem",
  },
  link: {
    textDecoration: "none",
    color: "white",
    fontSize: "16px",
    marginLeft: "70px",
    "&:hover": {
      color: "yellow",
      borderBottom: "1px solid white",
    },
  },
}));

function Navbar() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <AppBar position="static" className={classes.appBarBg}>
      <CssBaseline />
      <Toolbar>

        {isMobile ? (
          <DrawerComponent />
        ) : (
          <>
            <Link className={classes.link} to="/">
              <Typography className={classes.logo}>
                <img
                  className={classes.imgDesktop}
                  src={`${imgRoot}/ryo-sushi.png`}
                />
              </Typography>
            </Link>
            <div className={classes.navlinks}>
              <Link className={classes.link} to="/">
                Home
              </Link>
              <Link className={classes.link} to="/menu">
                Menu
              </Link>
              <Link className={classes.link} to="/about-us">
                About us
              </Link>
              <Link className={classes.link} to="/contact-us">
                Contact us
              </Link>
              <a className={classes.link} href="https://orderonlinemenu.com/RyoSushi" target='_blank'>Order Online</a>
            </div>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}
export default Navbar;
